import { attributes, define } from "@type-r/models";
import { Loading } from "lqx-react";
import * as React from "react";
import { globalStore } from "api";
import { OpenItems } from "../../common/open-items";
import { PendingActionsInvoices } from "../../api";

@define 
export class DisputedInvoicesState extends attributes({
    invoices: [PendingActionsInvoices],
    isReady: Boolean
}){
    async fetch(){   
        const disputedInvoices = await PendingActionsInvoices.fetchDisputedInvoices();
        this.invoices.set(disputedInvoices);

        this.invoices.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        return this;
    } 

    getCount(){
        return this.invoices.reduce((sum:number, curr) => sum + (curr ? curr.count : 0), 0);
    }   
}

export const DisputedInvoices = ({ state }: { state: DisputedInvoicesState }) => {

    return (
        state.isReady ?
            <OpenItems
                title={`Open items (${state.getCount()})`}
                invoices={state.invoices}
                linkUrl='/invoices/all'
                bucket='disputed'
            />
        :
            <Loading />
    );
}